/* eslint-disable */
import React, { useEffect, useState } from 'react'
import ActionButton from '../../framework/forms/helpercomponents/buttons/ActionButton';
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { ENTITYNAME, ACTIVITY, OFFSET, LOCALSTORAGE_KEY, MILLISECONDSINADAY, TOAST_TYPES } from "../../framework/constant/constant";
import * as API from "../../framework/API/api";
import { utility } from '../../framework/utility/utilityProvider';
import moment from 'moment';
import { useTranslation } from '../../locale/useTranslation';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import BossDialog from '../../components/BossDialog';
import ToastNotification from '../../components/ToastNotification';

export const CopySchedule = (props) => {

    const preferenceData = utility.getValue(LOCALSTORAGE_KEY.planningpreference);
    const offSetHours = new Date(preferenceData?.data[0]?.value?.TimeZone?.DayStartTime ?? 0).getUTCHours();
    const offsetTime = offSetHours * 3600000;

    const propStartDate = moment(props.plannerPayload.date)
    .startOf('week');
const propEndDate = moment(props.plannerPayload.date)
    .endOf('week');

    const startDate = propStartDate.format('YYYY-MM-DDTHH:mm');
    const endDate = propEndDate.format('YYYY-MM-DDTHH:mm');
    const currentUser = utility.getValue(LOCALSTORAGE_KEY.userData);

    var defaultDataItem = {
        FromDate: startDate,
        ToDate: endDate,
        CopyTo_FromDate: startDate,
        CopyTo_ToDate: propEndDate.diff(propStartDate),
        CopyFrom_Channel: props.plannerPayload.channels[0],
        CopyTo_Channel: props.plannerPayload.channels[0],
        Activity: ACTIVITY[0],
        Move: false
    }

    const [channel, setChannel] = useState([]);
    const [dataItem, setDataItem] = useState(defaultDataItem);
    const [statusMessage, setStatusMessage] = useState("");
    const [showInvalidDataGrid, setShowInvalidDataGrid] = useState(false);
    const [inValidShortFormData, setInValidShortFormData] = useState([]);
    const [disable, setDisable] = useState(false);

    const lang = useTranslation();

    useEffect(() => {
        loadcombo();
    }, []);



    const loadcombo = async () => {
        var channelRes = await API.getDataLookup(ENTITYNAME.Channel);
        setChannel(channelRes.data);
    }

    const onChange = (e) => {
        if (e.target.name == 'ToDate' || e.target.name == 'FromDate' || e.target.name == 'CopyTo_FromDate') {
            const fromDateMs = new Date(dataItem.FromDate).getTime();
            const toDateMs = new Date(e.target.value).getTime();
          
            // Difference in days
            const dayDifference = Math.floor(
                (toDateMs - fromDateMs) / (1000 * 60 * 60 * 24)
            );

            const copyFromDateMs = new Date(dataItem.CopyTo_FromDate).getTime();

            // Add day difference in milliseconds
            const copyToDateMs =
                copyFromDateMs + (dayDifference * 24 * 60 * 60 * 1000);
            setDataItem({
                ...dataItem,
                CopyTo_ToDate: copyToDateMs,
                [e.target.name]: e.target.value
            });
        } else if (e.target.name == 'Move') {
            setDataItem({ ...dataItem, Move: !dataItem.Move });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const onCopySchedule = async () => {
       
        setDisable(true);
        console.log(dataItem.ToDate);
        if (!utility.isValidDate(dataItem.FromDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_valid_copy_from_date_error_message });
            setStatusMessage(`${lang.please_enter_valid_copy_from_date_error_message}`);
            setDisable(false);
            return;
        }
        if (!utility.isValidDate(dataItem.ToDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_valid_copy_to_date_error_message });
            setStatusMessage(`${lang.please_enter_valid_copy_to_date_error_message}`);
            setDisable(false);
            return;
        }
        if (!utility.isValidDate(dataItem.CopyTo_FromDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_valid_copy_to_from_date_error_message });
            setStatusMessage(`${lang.please_enter_valid_copy_to_from_date_error_message}`);
            setDisable(false);
            return;
        }
        // if (!utility.isValidDate(dataItem.CopyTo_ToDate)) {
        // ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_valid_copy__to_todate_error_message });
        //     setStatusMessage(`${lang.please_enter_valid_copy__to_todate_error_message}`);
        //     setDisable(false);
        //     return;
        // }

        //Old comment By Navin
        //let copyTo_FromDate = utility.getDateInputAsUtcMilliseconds(dataItem.CopyTo_FromDate);
        //let copyTo_ToDate = utility.getDateInputAsUtcMilliseconds(dataItem.CopyTo_ToDate);
        //let fromDate = utility.getDateInputAsUtcMilliseconds(dataItem.FromDate);
        //let toDate = utility.getDateInputAsUtcMilliseconds(dataItem.ToDate);

        ///add New By Navin
        let [fromdate, fromdatettime] = dataItem.FromDate?.split('T');
        let [todate, todatetime] = dataItem.ToDate?.split('T');
        let [copyto_fromdate, copyto_fromdatetime] = dataItem.CopyTo_FromDate?.split('T');
       // let [copyto_todate, copyto_todatetime] = dataItem.CopyTo_ToDate?.split('T');

        let fromDate = utility.getDateInputAsUtcMilliseconds(fromdate) + utility.convertShortTimeStringToMilliSeconds(fromdatettime);
        let toDate = utility.getDateInputAsUtcMilliseconds(todate) + utility.convertShortTimeStringToMilliSeconds(todatetime);
        let copyTo_FromDate = utility.getDateInputAsUtcMilliseconds(copyto_fromdate) + utility.convertShortTimeStringToMilliSeconds(copyto_fromdatetime);
        //let copyTo_ToDate = utility.getDateInputAsUtcMilliseconds(copyto_todate) + utility.convertShortTimeStringToMilliSeconds(copyto_todatetime);


        if (fromDate > toDate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.invalid_date_range_copy_from_planning_error_message });
            setStatusMessage(`${lang.invalid_date_range_copy_from_planning_error_message}`);
            setDisable(false);
            return;
        }

        if ((toDate - fromDate) / 86400000 >= 31) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.date_range_between_seven_day_copy_from_planning_error_message });
            setStatusMessage(() => `${lang.date_range_between_seven_day_copy_from_planning_error_message}`);
            setDisable(false);
            return;
        }

        // if (copyTo_FromDate > copyTo_ToDate) {
        // ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.invalid_date_range_copy_to_planning_error_message });
        //     setStatusMessage(`${lang.invalid_date_range_copy_to_planning_error_message}`);
        //     setDisable(false);
        //     return;
        // }

        if ((fromDate - toDate) / 86400000 >= 31) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.date_range_between_seven_day_copy_to_planning_error_message });
            setStatusMessage(() => `${lang.date_range_between_seven_day_copy_to_planning_error_message}`);
            setDisable(false);
            return;
        }

        //CHECK DAYS DIFF.
        // if ((toDate - fromDate) != (copyTo_ToDate - copyTo_FromDate)) {
        // ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.copy_from_and_copy_to_date_range_should_be_same });
        //     setStatusMessage(() => `${lang.copy_from_and_copy_to_date_range_should_be_same}`);
        //     setDisable(false);
        //     return;
        // }

        setStatusMessage(() => `${lang.data_copy_schedule_please_wait_copyschedule_error_message}`);

        let invalidShortForms = 0;
        //CHECK VALIDATION FIRST
        const diff = toDate - fromDate;
        let checkCopyScheduleVadilation = {
            payload: {
                ///Change and replace By Navin 
                // CopyFromDate: fromDate + offsetTime,
                // CopyTillDate: utility.addTimeToDateInMilliseconds(toDate, 23, 59, 59, 999) + offsetTime,
                // CopyTo_FromDate: copyTo_FromDate + offsetTime,
                // CopyTo_ToDate: copyTo_ToDate + offsetTime,
              
                CopyFromDate: fromDate,
                CopyTillDate: toDate,
                CopyTo_FromDate: copyTo_FromDate,
                CopyTo_ToDate: copyTo_FromDate + diff,

                FromChannel: dataItem.CopyFrom_Channel,
                ToChannel: dataItem.CopyTo_Channel,
                Activity: dataItem.Activity,
                Move: dataItem.CopyFrom_Channel._id == dataItem.CopyTo_Channel._id ? dataItem.Move : false
            },
            user: currentUser
        }

        let isValid = await API.checkCopyScheduleVadilation(checkCopyScheduleVadilation);
        console.log(isValid);
        if (isValid.success) {

            console.log("VALID !!!");

        } else {
            setStatusMessage(isValid.message);
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: isValid.message });
            setDisable(false);
            return;
        }

        //SEND API REQUEST DAY BY DAY
        let tempFromDate = fromDate;
        let tempCopyTo_FromDate = copyTo_FromDate;
        
        while (tempFromDate <= toDate) {

            let currentFromTillDate = (tempFromDate + MILLISECONDSINADAY - 1);
            let currentCopyTo_ToDate = (tempCopyTo_FromDate + MILLISECONDSINADAY - 1);

            // if to date is going beyond actual to date then set it to actual to date
            if(currentFromTillDate > toDate){
                currentFromTillDate = toDate;
            }

            var data = {
                payload: {

                    ///Change and replace By Navin 
                    // CopyFromDate: tempFromDate + offsetTime,
                    // CopyTillDate: utility.addTimeToDateInMilliseconds(tempFromDate, 23, 59, 59, 999) + offsetTime,
                    // CopyTo_FromDate: tempCopyTo_FromDate + offsetTime,
                    // CopyTo_ToDate: tempCopyTo_FromDate + MILLISECONDSINADAY + offsetTime,

                    CopyFromDate: tempFromDate,
                    CopyTillDate: currentFromTillDate,
                    CopyTo_FromDate: tempCopyTo_FromDate,
                    CopyTo_ToDate: currentCopyTo_ToDate,
                    FromChannel: dataItem.CopyFrom_Channel,
                    ToChannel: dataItem.CopyTo_Channel,
                    Activity: dataItem.Activity,
                    Move: dataItem.CopyFrom_Channel._id == dataItem.CopyTo_Channel._id ? dataItem.Move : false
                },
                user: currentUser
            }

            ///Change and replace By Navin 
            //setStatusMessage(`Copying Schedule For Date : ${utility.convertMilisecondsToDateString(tempCopyTo_FromDate + offsetTime)} - ${utility.convertMilisecondsToDateString(tempCopyTo_FromDate + MILLISECONDSINADAY + offsetTime)}`);
            setStatusMessage(`Copying Schedule For Date : ${utility.convertMilisecondsToDateTimeStringWithFrames(tempFromDate)} - ${utility.convertMilisecondsToDateTimeStringWithFrames(currentFromTillDate)}`);

            // copySchedule
            var res = await API.copySchedule(data);
            console.log(res);
            if (res.success) {
                invalidShortForms = invalidShortForms + res.data.invalidShortForms;
            } else {

                setStatusMessage(res.message);
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
                invalidShortForms = invalidShortForms + res.data.invalidShortForms;
                break;
            }

            // move both dates by next 24 hours
            tempFromDate += MILLISECONDSINADAY;
            tempCopyTo_FromDate += MILLISECONDSINADAY;
        }
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Planning replicated successfully" });
        props.planningLoading();
        props.closeForm();
        setInValidShortFormData(invalidShortForms ?? []);
        setDisable(false);

    }

    return (<div>
        <BossDialog
            title={lang.copy_transfer_schedule_header_dialog}
            onClose={props.closeForm}
            width={"960px"}
        >
            <div className='row' style={{ display: 'flex', marginLeft: '-25px' }}>
                <div className="col">
                    <ActionButton title={lang.create_button_tootltip} name={lang.create_button_text} onClick={onCopySchedule} disabled={disable} />
                    <ActionButton style={{ marginLeft: '5px', borderRadius: '5px' }} title={lang.cancel_button_tooltip} name={lang.cancel_button_text} onClick={props.closeForm} btnColor={'danger'} disabled={disable} />
                    {inValidShortFormData.length > 0 && <ActionButton style={{ marginLeft: '5px', borderRadius: '5px' }} title={lang.invalid_short_forms} name={lang.invalid_tooltip} onClick={() => setShowInvalidDataGrid(true)} btnColor={'info'} disabled={disable} />}
                </div>
            </div>
            <div className='row mt-2'>
                <div className='col-12'>
                    <div style={{ margin: "0px 0px 0px 0px", border: '1px solid #c4c2c2', borderRadius: '5px!important' }}>
                        <div className='row mt-2 mr-1 ml-1'>
                            <div className='col-6' >
                                <div style={{ border: '1px solid #c4c2c2', borderRadius: '5px', pading: '5px 10px' }} >
                                    <div className='row m-1'>
                                        <div className='col'>{lang.copy_from_label}</div>
                                        <div className='col text-right' style={{ color: 'gray', fontSize: '11px', marginTop: '2px', marginRight: '-10px' }}>
                                            ({lang.selected_days_label} : {utility.getDaysAndHoursDifference(dataItem.FromDate, dataItem.ToDate, true)})
                                        </div>
                                    </div>
                                    <div className='row m-1'>
                                        <div className='col-6'>
                                            <div className="form-group">
                                                <label htmlFor="">{lang.from_label}</label>
                                                <input
                                                    type="datetime-local"
                                                    className="form-control form-control-sm"
                                                    name="FromDate"
                                                    value={dataItem.FromDate}
                                                    onChange={onChange}
                                                />
                                            </div>
                                        </div>
                                        <div className='col-6'>
                                            <div className="form-group">
                                                <label htmlFor="">{lang.to_label}</label>
                                                <input
                                                    type="datetime-local"
                                                    className="form-control form-control-sm"
                                                    name="ToDate"
                                                    value={dataItem.ToDate}
                                                    onChange={onChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='col-6'>
                                <div style={{ border: '1px solid #c4c2c2', borderRadius: '5px', pading: '5px 10px' }}>
                                    <div className='row m-1'>
                                        <div className='col'>{lang.copy_to_label}</div>
                                        <div className='col text-right' style={{ color: 'gray', fontSize: '11px', marginTop: '2px', marginRight: '-10px' }}>
                                            ({lang.selected_days_label} : {utility.getDaysAndHoursDifference(dataItem.FromDate, dataItem.ToDate, true)})
                                        </div>
                                    </div>
                                    <div className='row m-1'>
                                        <div className='col-12'>
                                            <div className="form-group">
                                                <label htmlFor="">{lang.from_label}</label>
                                                <input
                                                    type="datetime-local"
                                                    className="form-control form-control-sm"
                                                    name="CopyTo_FromDate"
                                                    value={dataItem.CopyTo_FromDate}
                                                    onChange={onChange}
                                                />
                                            </div>
                                        </div>

                                      
                                          

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row mr-1 ml-1 mt-2'>
                            <div className='col-3'>
                                <div className="form-group">
                                    <label htmlFor="TabView">{lang.from_channel_label}</label>
                                    <DropDownList
                                        style={{ backgroundColor: "white" }}
                                        data={channel}
                                        name="CopyFrom_Channel"
                                        textField="FullChannelName"
                                        dataItemKey="_id"
                                        value={dataItem.CopyFrom_Channel}
                                        onChange={onChange}
                                        validator={(value) => value ? "" : "Please select the value"}
                                    />
                                </div>
                            </div>
                            <div className='col-3'>
                                <div className="form-group">
                                    <label htmlFor="TabView">{lang.to_channel_label}</label>
                                    <DropDownList
                                        style={{ backgroundColor: "white" }}
                                        data={channel}
                                        name="CopyTo_Channel"
                                        textField="FullChannelName"
                                        dataItemKey="_id"
                                        value={dataItem.CopyTo_Channel}
                                        onChange={onChange}
                                        validator={(value) => value ? "" : "Please select the value"}
                                    />
                                </div>
                            </div>
                            <div className='col-4'>
                                <div className="form-group">
                                    <label htmlFor="TabView">{lang.activity_label}</label>
                                    <DropDownList
                                        style={{ backgroundColor: "white" }}
                                        data={ACTIVITY}
                                        name="Activity"
                                        textField="Description"
                                        dataItemKey="ID"
                                        value={dataItem.Activity}
                                        onChange={onChange}
                                        validator={(value) => value ? "" : "Please select the value"}
                                    />
                                </div>
                            </div>
                            {dataItem.CopyFrom_Channel._id == dataItem.CopyTo_Channel._id && <div className='col-2' style={{ margin: '25px 0px 0px 0px' }}>
                                <input type="checkbox" name="Move" value={dataItem.Move} checked={dataItem.Move} onChange={onChange} />
                                <label className="pl-1" htmlFor="Move">{'Move'}</label>
                            </div>}
                        </div>

                    </div>
                </div>
            </div>
            <div className="row mt-2">
                <div className="col-12" style={{ textAlign: "left" }}>
                    <div className="form-group">
                        <div style={{ height: "45px", backgroundColor: "#cce5ed" }} className="form-control form-control-sm" name="DisplayName">{statusMessage}</div>
                    </div>
                </div>
            </div>

        </BossDialog>

        {showInvalidDataGrid && <BossDialog
            title={'Expired Short Forms'}
            onClose={() => setShowInvalidDataGrid(false)}
            width={"500px"}
        >
            <div className='row'>
                <div className='col'>
                    <Grid data={inValidShortFormData} style={{ height: "20vh" }} className="mt-2">
                        <GridColumn field="mediaEpisode.Title" title={lang.title_label} />
                        <GridColumn field="mediaEpisode.AssetId" title={lang.asset_id_label} />
                        <GridColumn field="mediaEpisode.MediaCategoryType.Description" title={lang.media_category_type_label} />
                    </Grid>
                </div>
            </div>
        </BossDialog>}
    </div>
    )
}
